<template>
  <sub-page :title="title">
    <div class="jp-detail-page">

      <div class="record-sheet" ref="sheet">
        <div class="sheet-header">
          <div class="main-title">江苏省企业职工基本养老保险权益记录单<br />（参保人员）</div>
          <div class="qr-wrap">
            <img v-if="qrDataUrl" :src="qrDataUrl" class="qr-img" alt="验证二维码" />
            <div class="qr-tip">请使用官方江苏智慧人社APP扫描验证</div>
          </div>
        </div>

        <div class="info-grid">
          <div class="info-item"><span class="info-label">姓名<span class="colon">:</span></span><div class="info-value" style="margin-left: 15px;">{{ base.name }}</div></div>
          <div class="info-item"><span class="info-label">性别<span class="colon">:</span></span><div class="info-value" style="margin-left: 10px;">{{ base.gender }}</div></div>
          <div class="info-item"><span class="info-label">社会保障号<span class="colon">:</span></span><div class="info-value" style="margin-left: 10px;">{{ base.idNo }}</div></div>
          <div class="info-item"><span class="info-label">参保状态<span class="colon">:</span></span><div class="info-value" style="margin-left: 10px;">{{ base.status }}</div></div>
          <div class="info-item company-item fit"><span class="info-label">现参保单位全称<span class="colon">:</span></span><div class="info-value" style="margin-left: 10px;">{{ maskVal(base.companyFull, '单位名称') }}</div></div>
          <div class="info-item"><span class="info-label">现参保地<span class="colon">:</span></span><div class="info-value" style="margin-left: 10px;">{{ base.place }}</div></div>
        </div>
        <div class="page-tip">共1页 第1页</div>

        <div class="table-scroll">
        <table class="sheet-table">
          <colgroup>
            <col style="width:calc(208 * var(--w))" />
            <col style="width:calc(49 * var(--w))" />
            <col style="width:calc(105 * var(--w))" />
            <col style="width:calc(94 * var(--w))" />
            <col style="width:calc(278 * var(--w))" />
            <col style="width:calc(153 * var(--w))" />
            <col style="width:calc(87 * var(--w))" />
          </colgroup>
          <tbody>
            <tr>
              <td class="lbl">缴费起止年月</td>
              <td class="lbl">月数</td>
              <td class="lbl">缴费基数<br>（元）</td>
              <td class="lbl">个人缴费<br>（元）</td>
              <td class="lbl">单位全称</td>
              <td class="lbl">社会保险经办机构</td>
              <td class="lbl">备注</td>
            </tr>
            <tr class="fit-row" v-for="(row, idx) in displayRows" :key="idx">
              <td>{{ row.period }}</td>
              <td>{{ row.months }}</td>
              <td>{{ maskVal(row.base, '缴费基数') }}</td>
              <td>{{ maskVal(row.personal, '个人缴费金额') }}</td>
              <td>{{ maskVal(row.company, '单位名称') }}</td>
              <td>{{ row.agency }}</td>
              <td>{{ row.remark }}</td>
            </tr>
            <!-- 所选范围内无缴费记录 -->
            <tr v-if="displayRows.length === 0">
              <td colspan="7" class="empty-row">所选年月范围内暂无缴费记录</td>
            </tr>
            <tr class="fit-row">
              <td>合计</td>
              <td>{{ totalMonths }}</td>
              <td>--</td>
              <td>{{ maskVal(totalPersonal, '个人缴费金额') }}</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
            </tr>
          </tbody>
        </table>
        </div>

        <div class="remark">
          <p>备注：1.本权益记录单为打印时参保情况，供参考，由参保人员自行保管。</p>
          <p class="remark-indent">2.本权益单已签具电子印章，不再加盖鲜章。</p>
          <p class="remark-indent">3.本权益记录单出具后有效期限（6个月）内，如需核对真伪，请使用江苏智慧人社APP，扫描右上方二维码进行验证（可多次验证）。</p>
        </div>

        <div class="seal-block">
          <img :src="sealImg" class="seal-img" alt="电子专用章" />
          <!-- 签章：独立于印章，黑色字体，位于印章正下方 -->
          <div class="seal-info">
            <div class="seal-mark">(盖章)</div>
            <div class="seal-time">{{ sealDate }}</div>
          </div>
        </div>
      </div>

      <!-- 底部全宽灰色操作带：仅APP内显示，扫一扫托管页环境隐藏保存功能 -->
      <div class="sheet-footer" v-if="!isShareHost">
        <button class="save-btn" :disabled="saving" @click="saveImage">{{ saving ? '正在生成…' : '保存为图片' }}</button>
      </div>

      <!-- APP环境：全屏图片预览，长按可保存到相册（点击空白关闭） -->
      <div class="img-preview-mask" v-if="showPreviewImg" @click="showPreviewImg = false">
        <div class="img-preview-tip">长按图片可保存到相册，点击空白处关闭</div>
        <img :src="previewImg" class="img-preview-img" alt="权益记录单" />
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'
import html2canvas from 'html2canvas'
import sealImg from '../assets/icons/electronic-seal-trans.png'
import { buildShareUrl, generateQrDataUrl } from '../utils/share'

// 精确到分（2位小数）的四舍五入，加 Number.EPSILON 修正浮点误差
function round2(n) {
  return Math.round((n + Number.EPSILON) * 100) / 100
}

// 截图前把区域内非data图片（外链二维码/本地印章）带重试地转成 dataURL，
// 规避第三方图片跨域偶发失败导致导出图缺图；完成后返回还原函数
function inlineImages(root) {
  const nodes = Array.from(root.querySelectorAll('img')).filter(img => !/^data:/i.test(img.src))
  return Promise.all(nodes.map(img => new Promise(resolve => {
    const original = img.src
    let n = 0
    const load = () => {
      n++
      const im = new Image()
      im.crossOrigin = 'anonymous'
      let settled = false
      const timer = setTimeout(fail, 3000)
      function fail() {
        if (settled) return
        settled = true
        clearTimeout(timer)
        if (n < 3) setTimeout(load, 200)
        else resolve()
      }
      im.onload = () => {
        if (settled) return
        settled = true
        clearTimeout(timer)
        try {
          const c = document.createElement('canvas')
          c.width = im.naturalWidth
          c.height = im.naturalHeight
          c.getContext('2d').drawImage(im, 0, 0)
          img.src = c.toDataURL('image/png')
          img.dataset.origSrc = original
        } catch (e) { /* 跨域被拒则保留原地址 */ }
        resolve()
      }
      im.onerror = fail
      im.src = original
    }
    load()
  }))).then(() => () => {
    root.querySelectorAll('img[data-orig-src]').forEach(img => {
      img.src = img.dataset.origSrc
      delete img.dataset.origSrc
    })
  })
}

// 完整历史缴费记录（按 PDF 仿真），start/end 为年月数字字符串便于比较
// 提升为模块常量并导出，供社保个人权益记录单页复用同一数据源
export const PENSION_ALL_ROWS = [
  { start: '201609', end: '201706', period: '2016年9月-2017年6月', months: 10, base: '2628', personal: '2759.40', company: '中储科技有限公司', agency: '南京市溧水区', remark: '' },
  { start: '201707', end: '201806', period: '2017年7月-2018年6月', months: 12, base: '2940', personal: '3704.40', company: '中储科技有限公司', agency: '南京市溧水区', remark: '' },
  { start: '201807', end: '201906', period: '2018年7月-2019年6月', months: 12, base: '3125', personal: '3907.56', company: '中储科技有限公司', agency: '南京市溧水区', remark: '' },
  { start: '201907', end: '202006', period: '2019年7月-2020年6月', months: 12, base: '3368', personal: '4243.68', company: '中储科技有限公司', agency: '南京市溧水区', remark: '' },
  { start: '202007', end: '202106', period: '2020年7月-2021年6月', months: 12, base: '3368', personal: '4243.68', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区', remark: '' },
  { start: '202107', end: '202112', period: '2021年7月-2021年12月', months: 6, base: '3800', personal: '2304.0', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区', remark: '' },
  { start: '202201', end: '202212', period: '2022年1月-2022年12月', months: 12, base: '4250', personal: '5355.0', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区', remark: '' },
  { start: '202301', end: '202312', period: '2023年1月-2023年12月', months: 12, base: '4494', personal: '5662.44', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区', remark: '' },
  { start: '202401', end: '202412', period: '2024年1月-2024年12月', months: 12, base: '4879', personal: '6147.60', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区', remark: '' },
  { start: '202501', end: '202608', period: '2025年1月-2026年8月', months: 20, base: '4952', personal: '10399.20', company: '江苏超芯星半导体有限公司', agency: '南京市江北新区', remark: '' }
]

export default {
  name: 'JiangsuPensionInsured',
  components: { SubPage },
  data() {
    return {
      sealImg,
      title: '个人权益记录查询打印',
      // 保存图片相关状态
      saving: false,        // 是否正在生成
      showPreviewImg: false,// APP环境是否显示图片预览
      previewImg: '',       // 生成的图片DataURL
      qrDataUrl: '',        // 动态二维码图片dataURL
      // 查询页选择的起止年月（默认全量历史）
      startDate: this.$route.query.start || '201609',
      endDate: this.$route.query.end || '202608',
      // 需脱敏的字段（来自查询页勾选）
      maskList: (this.$route.query.mask || '').split(',').filter(Boolean),
      base: {
        name: '戴义杰',
        gender: '男',
        idNo: '341221199210285619',
        status: '正常',
        companyFull: '江苏超芯星半导体有限公司',
        place: '南京市江北新区'
      },
      // 完整历史缴费记录：复用模块常量（同一数据源）
      allRows: PENSION_ALL_ROWS
    }
  },
  computed: {
    // 扫一扫托管页环境（https且非本机）：隐藏「保存为图片」等APP内功能
    isShareHost() {
      return location.protocol.indexOf('http') === 0 &&
        location.hostname !== 'localhost' &&
        location.hostname !== '127.0.0.1'
    },
    sealDate() {
      const now = new Date()
      return `${now.getFullYear()}年${now.getMonth() + 1}月${now.getDate()}日`
    },
    // 按查询起止年月裁剪：与区间有交集的历史段，仅保留交集部分并重算月数/个人缴费
    displayRows() {
      return this.allRows
        .filter(row => row.end >= this.startDate && row.start <= this.endDate)
        .map((row, ri, list) => {
          // 交集起点
          const s = row.start >= this.startDate ? row.start : this.startDate
          let e = row.end <= this.endDate ? row.end : this.endDate
          // 不延伸模拟月份：查询终止月超出真实数据末端时截断
          if (ri === list.length - 1 && this.endDate > row.end) {
            e = row.end
          }
          // 完全落在区间内且未延伸，原样返回
          if (s === row.start && e === row.end) return row
          const months = this.monthCount(s, e)
          // 按月费率（该段总个人缴费 / 原月数）重算，结果精确到分
          const monthRate = parseFloat(row.personal) / row.months
          return Object.assign({}, row, {
            start: s,
            end: e,
            period: this.formatPeriod(s, e),
            months,
            personal: round2(monthRate * months).toFixed(2)
          })
        })
    },
    // 展示行月数合计
    totalMonths() {
      return this.displayRows.reduce((sum, row) => sum + row.months, 0)
    },
    // 展示行个人缴费合计：累加后精确四舍五入到分
    totalPersonal() {
      const total = this.displayRows.reduce((sum, row) => sum + parseFloat(row.personal), 0)
      return round2(total).toFixed(2)
    }
  },
  mounted() {
    // 动态二维码：按起止年月、脱敏字段生成（参数变化时刷新）
    this.refreshQr()
    // 表格/信息区自适应：字体加载后及窗口尺寸变化时重新收缩适配（与SocialInsuranceDetail一致）
    this.$nextTick(this.fitCells)
    setTimeout(this.fitCells, 350)
    // 字体真正就绪后再测一次：保证用 RSJ Sans 度量计算内联px，与浏览器结果一致
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.$nextTick(this.fitCells))
    }
    window.addEventListener('resize', this.fitCells)
    window.addEventListener('orientationchange', this.fitCells)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fitCells)
    window.removeEventListener('orientationchange', this.fitCells)
  },
  watch: {
    // 查询条件变化后重新适配并刷新二维码
    '$route'() {
      this.refreshQr()
      this.$nextTick(this.fitCells)
      setTimeout(this.fitCells, 350)
    }
  },
  methods: {
    // 生成动态二维码：内容为托管页 URL，携带起止年月与脱敏字段，扫码后还原本页
    async refreshQr() {
      try {
        const url = buildShareUrl('/jiangsu-pension-insured', this.startDate, this.endDate, this.maskList)
        this.qrDataUrl = await generateQrDataUrl(url)
      } catch (e) { /* 生成失败保留空白，不阻塞页面 */ }
    },
    // 收缩适配：目标元素强制单行，宽度不够时逐档缩小字号，杜绝APK折行
    fitCells() {
      const sheet = this.$refs.sheet
      if (!sheet) return
      const els = sheet.querySelectorAll('.info-item.fit, .fit-row td')
      // 先全部恢复样式表默认字号并强制单行
      els.forEach(el => {
        el.style.whiteSpace = 'nowrap'
        el.style.fontSize = ''
      })
      // 强制回流后逐档收缩
      void sheet.offsetWidth
      els.forEach(el => {
        let fs = parseFloat(getComputedStyle(el).fontSize)
        let guard = 0
        while (el.scrollWidth > el.clientWidth && fs > 9 && guard < 40) {
          fs -= 0.5
          el.style.fontSize = fs + 'px'
          guard++
        }
        // 缩到下限仍溢出：放弃单行允许自然换行，杜绝内容横向覆盖相邻列
        if (el.scrollWidth > el.clientWidth) {
          el.style.whiteSpace = 'normal'
        }
      })
    },
    // 年月字符串转月序号
    toMonth(ym) {
      return parseInt(ym.substring(0, 4)) * 12 + parseInt(ym.substring(4, 6))
    },
    // 起止年月之间的月数（含首尾）
    monthCount(s, e) {
      return this.toMonth(e) - this.toMonth(s) + 1
    },
    // 单个年月格式化为 "YYYY年M月"
    fmtYM(ym) {
      return `${parseInt(ym.substring(0, 4))}年${parseInt(ym.substring(4, 6))}月`
    },
    // 区间文案：单月直接显示，区间用短横线连接
    formatPeriod(s, e) {
      return s === e ? this.fmtYM(s) : `${this.fmtYM(s)}-${this.fmtYM(e)}`
    },
    // 字段需脱敏则返回 ***，否则返回原值
    maskVal(value, field) {
      return this.maskList.includes(field) ? '***' : value
    },
    // 将权益记录单生成为图片并保存
    async saveImage() {
      if (this.saving) return
      this.saving = true
      // 先把二维码等转成 dataURL（带重试），保证导出图与当前页面一致；返回还原函数
      const restore = await inlineImages(this.$refs.sheet)
      html2canvas(this.$refs.sheet, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false
      }).then(canvas => {
        const dataUrl = canvas.toDataURL('image/png')
        // Cordova APP 内 a.download 不生效：弹出大图供用户长按保存到相册
        if (window.cordova) {
          this.previewImg = dataUrl
          this.showPreviewImg = true
        } else {
          // 浏览器环境：触发文件下载
          const link = document.createElement('a')
          link.download = '江苏省企业职工基本养老保险权益记录单（参保人员）.png'
          link.href = dataUrl
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }).catch(err => {
        alert('图片生成失败：' + (err && err.message ? err.message : err))
      }).then(() => {
        this.saving = false
        restore()
      })
    }
  }
}
</script>

<style scoped>
.jp-detail-page {
  background: #FFFFFF;
  min-height: 100%;
  /* 撑满 page-body，背景100%铺满 */
  flex: 1;
  /* 纵向弹性：底部灰带在内容不足一屏时自动填满剩余高度 */
  display: flex;
  flex-direction: column;
}
.record-sheet {
  position: relative;
  background: #FFFFFF;
  /* 对照设计稿：width:90%且无横向内边距（1080画布内容区x50..1024=974） */
  width: 90%;
  margin: 0 auto;
  padding: calc(10 * var(--w)) 0 calc(580 * var(--w));
}
.sheet-header {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-top: calc(16 * var(--w));
  margin-top: 20px;
}
.main-title {
  flex: 1;
  min-width: 0;
  text-align: center;
  font-size: calc(34 * var(--w));
  font-weight: bold;
  color: #323233;
  line-height: 1.7;
  margin: calc(10 * var(--w)) 0 calc(28 * var(--w));
}
.qr-wrap {
  /* 绝对定位脱离文档流：不挤占标题宽度，使标题相对整页居中（对照设计稿3.jpg） */
  position: absolute;
  top: calc(16 * var(--w));
  right: 0;
  width: calc(240 * var(--w));
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.qr-img {
  width: calc(120 * var(--w));
  height: calc(120 * var(--w));
  margin-bottom: 15px;
}
.qr-tip {
  font-size: calc(16 * var(--w));
  color: #323233;
  margin-top: calc(10 * var(--w));
  line-height: 1.4;
  white-space: nowrap;
}
.info-grid {
  display: grid;
  grid-template-columns: 52% 48%;
  font-size: calc(16 * var(--w));
  color: #323233;
  line-height: 2.4;
  margin: calc(50 * var(--w)) 0 calc(8 * var(--w));
}
.info-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info-item:nth-child(even) {
  padding-left: calc(60 * var(--w));
}
/* 「现参保单位全称」(第5项)：与「现参保地」同行；取消省略号截断，
   由JS收缩字号保证单位全名单行完整显示 */
.info-item.company-item {
  overflow: visible;
  text-overflow: clip;
}
.info-label {
  font-weight: bold;
  margin-right: 0;
}
.info-value {
  display: inline;
}
.colon-icon {
  display: none;
}
.colon {
  font-weight: bolder;
  
}
.page-tip {
  text-align: right;
  font-size: calc(22 * var(--w));
  color: #323233;
  margin: calc(6 * var(--w)) 0 calc(8 * var(--w));
}
/* 表格横向滚动兜底：列多/极端字体/窄屏下内容横向滚动而不折行重叠（滚动条已全局隐藏） */
.table-container {
  width: 100%;
}
.table-scroll {
  width: 100%;
}
.sheet-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
.sheet-table th,
.sheet-table td {

  border: 1px solid #1a1a1a;
  text-align: center;
  vertical-align: middle;
  /* 设计稿：16w字号（数字cap12px、汉字字高15px），常规字重；
     默认不折行，表头「缴费基数/个人缴费」用<br>确定性折两行 */
  font-size: calc(16 * var(--w)) !important;
  font-weight: normal;
  color: #1a1a1a;
  padding: calc(3 * var(--w)) calc(2 * var(--w));
  line-height: 1.2;
  white-space: nowrap;
  -webkit-font-smoothing: antialiased;
}
.sheet-table td.empty-row {
  padding: calc(40 * var(--w)) calc(6 * var(--w));
  color: #969799;
}
/* 表头行(第一行)：行高52w（设计稿700-752）；两行的「（元）」垂直居中 */
.sheet-table tbody tr:first-child td {
  height: calc(52 * var(--w));
}
/* 数据行(.fit-row)：行高31w（设计稿752-783），常规字重 */
.sheet-table .fit-row td {
  height: calc(31 * var(--w));
  font-weight: normal;
}
/* 合计行(末行)：行高26w（设计稿783-809） */
.sheet-table tbody tr:last-child td {
  height: calc(26 * var(--w));
}
/* scale方案已废弃（该机型WebView对scale不缩放字形却砍半排版宽度），
   不再需要.cell-inner内层 */
.remark {
  margin-top: calc(52 * var(--w));
  font-size: calc(22 * var(--w));
  color: #323233;
  line-height: 1.9;
}
.remark p {
  margin: 0;
}
.remark .remark-indent {
  text-indent: 2em;
  /* padding-left: calc(44 * var(--w)); */
}
.seal-block {
  bottom: 15px;
  position: relative;
  width: fit-content;
  margin-top: calc(-60 * var(--w));
  margin-left: auto;
  /* 对照设计稿3.jpg：印章右边缘距表格右边缘约109w */
  margin-right: calc(109 * var(--w));
}
.seal-img {
  margin-top: 18px;
  position: relative;
  z-index: 2;
  width: calc(196 * var(--w));
  height: calc(196 * var(--w));
  display: block;
}
.seal-info {
  position: absolute;
  inset: 0;
  z-index: 1;
}
.seal-mark {
  position: absolute;
  top: calc(50% - calc(12 * var(--w)));
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 2px;
  font-size: calc(19 * var(--w));
  color: #000;
  line-height: 1.4;
  white-space: nowrap;
}
.seal-time {
  margin-top: 2px;
  position: absolute;
  top: calc(50% + calc(29 * var(--w)));
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  /* 日期收小(19->17w)，保证单行，不与章内红字拥挤 */
  font-size: calc(17 * var(--w));
  color: #000;
  line-height: 1.4;
}
.save-btn {
  display: block;
  width: calc(480 * var(--w));
  height: calc(96 * var(--w));
  background: #1E7FFE;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(48 * var(--w));
  margin: 0 auto;
  cursor: pointer;
}
/* 底部全宽灰色操作带：按钮距灰带顶约73w（同参保人员权益记录单页） */
.sheet-footer {
  background: #F8F8F8;
  padding: calc(73 * var(--w)) 0;
  /* 内容不足一屏时灰带向下填满，按钮位置不变 */
  flex: 1;
}
.save-btn:disabled {
  opacity: 0.6;
  cursor: default;
}
/* APP环境图片预览遮罩 */
.img-preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.85);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: calc(40 * var(--w));
}
.img-preview-tip {
  color: #fff;
  font-size: calc(28 * var(--w));
  margin-bottom: calc(30 * var(--w));
}
.img-preview-img {
  max-width: 100%;
  max-height: 75vh;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/JiangsuPensionInsured.vue